var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-video"},[_c('div',{staticClass:"index-video__inner"},[(_vm.detail)?_c('video',{attrs:{"src":_vm.detail.videoUrl,"controls":"","muted":"","autoplay":""},domProps:{"muted":true}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }